/**
 * @file: ListModel.js
 * @author: liuye11(liuye11@baidu.com)
 */

import {assign, omit} from 'lodash';
import uri from '@baidu/ve-ria/utils/uri';
import ListModel from '../../common/FrameListModel';

export default class Model extends ListModel {

    /**
     * @override
     */
    pageType = '中间页';
    filter = assign(this.filter, {
        cardId: null,
        timeRange: null
    });

    init() {
        super.init();
        this.trendRequester = this.api.statsFrameTrend;
        this.listRequester = this.api.statsFrameList;
    }

    prepareParams(params) {
        params.cardId = params.associatedId;
        return omit(params, ['associatedId', 'associatedType']);
    }

    /**
     * @override
     */
    requestAderList() {}

    getReportUrl(params, reportType) {
        let routeQuery = this.getRouteQuery({});
        routeQuery.parentType = routeQuery.associatedType;
        routeQuery.parentId = routeQuery.associatedId;

        return uri.withQuery(
            `/stats/material/report/${reportType}`,
            assign(routeQuery, params)
        );
    }
}
